import { withDependentReferenceDataCustomField } from "../../lib/customHooks/useReferenceData";
import { isValidUrl } from "../../lib/utils";

// Appends two forward slashes to the beginning of the URL if the http protocol is not specified.
// This is necessary so the browser treats the link like an absolute url not a relative url.
const formatUrl = url => url.includes('http') ? url : `//${url}`;
const ButtonLinkPreview = ({
  url = '',
  buttonLabel
}) => <a className="foundry--button button--active button--contained button--wrap" target="_blank" href={url ? formatUrl(url) : url}>
    <span className="button--label">{buttonLabel}</span>
  </a>;
const DefaultLinkStylePreview = ({
  url = ''
}) => <a className="link--preview" target="_blank" href={url ? formatUrl(url) : url}>
    {url}
  </a>;
export const LinkPreview = withDependentReferenceDataCustomField('default', isValidUrl)(({
  style = 0,
  default: urlLink,
  mask: buttonLabel
}) => {
  return <>
      {style == 0 ? <ButtonLinkPreview url={urlLink} buttonLabel={buttonLabel} /> : <DefaultLinkStylePreview url={urlLink} />}
    </>;
});